import baseAxios from 'axios';
import API_URLS from '../../constants/api-urls';
import axios from '../../utils/axios';

const elasticSearch: Service = {
    cancelToken: null,
    // @ts-ignore
    get: (params = {}, useCancelToken) => {
        if (useCancelToken && elasticSearch.cancelToken) {
            elasticSearch.cancelToken();
        }

        return axios.get(API_URLS.ELASTIC_SEARCH, {
            cancelToken: new baseAxios.CancelToken((c) => {
                elasticSearch.cancelToken = c;
            }),
            // @ts-ignore
            params: { ...params, p: params.page || params.p }
        });
    }
};

export default elasticSearch;
